
<div>
  <div
    v-for="relation in accountRelations"
    :key="relation.clientIdOrId"
    v-tooltip="tooltipMessage(relation)"
  >

    <collapsible-section
      v-if="isEntityAccountRelation(relation)"
      class="collapse-item"
      :id="`objectModelRelationshipsCollapse-${relation.client_id}`"
      control-name="objectModelRelationshipsCollapse"
      :is-open="false"
    >
      <template #section-header>
        <row>
          <prefix>
            <icon glyph="relationships"/>
          </prefix>
          <column>
            {{ relation.label_title }}
          </column>
        </row>
      </template>
      <template v-if="fromModelView" #section-contents>
        <field-item
          :disabled="false"
          @click="select(handler.selectAccountRelation(relation, completePathForMetadata(relation, AccountRelationMetadataType.EntityOwnerName)))"
        >
          <row v-tooltip="tooltipMessage(relation)">
            <prefix>
              <icon glyph="member"/>
            </prefix>
            <column>
              Entity Owner Name
            </column>
          </row>
        </field-item>

        <field-item
          :disabled="false"
          @click="select(handler.selectAccountRelation(relation, completePathForMetadata(relation, AccountRelationMetadataType.EntityOwnerEmail)))"
        >
          <row v-tooltip="tooltipMessage(relation)">
            <prefix>
              <icon glyph="member"/>
            </prefix>
            <column>
              Entity Owner Email
            </column>
          </row>
        </field-item>

        <field-item
          :disabled="false"
          @click="select(handler.selectAccountRelation(relation, completePathForMetadata(relation, AccountRelationMetadataType.EntityName)))"
        >
          <row v-tooltip="tooltipMessage(relation)">
            <prefix>
              <icon glyph="member"/>
            </prefix>
            <column>
              Entity Name
            </column>
          </row>
        </field-item>

        <field-item
          :disabled="false"
          @click="select(handler.selectAccountRelation(relation, completePathForMetadata(relation, AccountRelationMetadataType.EntityPhone)))"
        >
          <row v-tooltip="tooltipMessage(relation)">
            <prefix>
              <icon glyph="member"/>
            </prefix>
            <column>
              Entity Phone
            </column>
          </row>
        </field-item>

        <field-item
          :disabled="false"
          @click="select(handler.selectAccountRelation(relation, completePathForMetadata(relation, AccountRelationMetadataType.EntityAddress)))"
        >
          <row v-tooltip="tooltipMessage(relation)">
            <prefix>
              <icon glyph="member"/>
            </prefix>
            <column>
              Entity Address
            </column>
          </row>
        </field-item>
      </template>

      <template v-else-if="!fromModelView" #section-contents>
        <field-item
          v-if="showEntityOption"
          :disabled="false"
          @click="select(handler.selectAccountRelation(relation, completePathForMetadata(relation, AccountRelationMetadataType.Entity)))"
        >
          <row v-tooltip="tooltipMessage(relation)">
            <prefix>
              <icon glyph="member"/>
            </prefix>
            <column>
              {{ relation.label_title }} (entity)
            </column>
          </row>
        </field-item>

        <field-item
          :disabled="false"
          @click="select(handler.selectAccountRelation(relation, completePathForMetadata(relation, AccountRelationMetadataType.EntityOwner)))"
        >
          <row v-tooltip="tooltipMessage(relation)">
            <prefix>
              <icon glyph="member"/>
            </prefix>
            <column>
              {{ relation.label_title }} (owner)
            </column>
          </row>
        </field-item>

        <field-item
          :disabled="false"
          @click="select(handler.selectAccountRelation(relation, completePathForMetadata(relation, AccountRelationMetadataType.EntityMembers)))"
        >
          <row v-tooltip="tooltipMessage(relation)">
            <prefix>
              <icon glyph="member"/>
            </prefix>
            <column>
              {{ relation.label_title }} (members)
            </column>
          </row>
        </field-item>
      </template>
    </collapsible-section>

    <field-item
      v-else
      :disabled="handler.isDisabled(relation, computedChildTreeContext)"
      @click="select(handler.selectAccountRelation(relation, completePathFor(relation)))"
    >
      <row
        v-tooltip="tooltipMessage(relation)"
      >
        <prefix>
          <icon glyph="member"/>
        </prefix>
        <column>
          {{relation.labelTitleDisplay}}
        </column>
      </row>
    </field-item>
  </div>
</div>
